<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config"; 
import store from "@/state/store";
import { MethodsActionsLoginSessionKey } from "@/state/helpers";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
export default {
  mixins: [Api, Sabit],
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout, 
  },
  data() {
    return {
      title: "Anasayfa",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },

      ],

      KullaniciYetkileri: store.getters["auth/UserRolles"],
      AuthKontrol: store.getters["auth/isAuth"],
      GetTalepDurum: null,
      GetTalepDurumYil: null,
      GetTalepDurumAy: null,
      Durumlar: {
        labels: [],
        GetTalepDurum: [], 
        GetTalepDurumYil: [],
        GetTalepDurumAy: []

      },
      DurumlarBireysel: {
        labels: [],
        GetTalepDurum: [],
        GetTalepDurumYil: [],
        GetTalepDurumAy: []
 
      },
      ecampususer:window.$cookies.get("ecampususer")


    };
  },
  methods: {
    ...MethodsActionsLoginSessionKey,
    Get() { },
    GecersizTalep(Durumlar){ 
      const gecersizIndex = Durumlar.labels.indexOf("Geçersiz Talep"); 
        const toplam = Durumlar.GetTalepDurum
          .filter((_, index) => index === gecersizIndex)   
          .reduce((acc, value) => acc + value, 0);   
          return toplam
    },
    TamamlananTalep(Durumlar){ 
      const tamamlandiIndex = Durumlar.labels.indexOf("Tamamlandı"); 
        const toplam = Durumlar.GetTalepDurum
          .filter((_, index) => index === tamamlandiIndex)   
          .reduce((acc, value) => acc + value, 0);   
          return toplam
    },
    TamamlanmayanaTalep(Durumlar){ 
      const tamamlandiIndex = Durumlar.labels.indexOf("Tamamlandı"); 
      const gecersizIndex = Durumlar.labels.indexOf("Geçersiz Talep");
        const toplam = Durumlar.GetTalepDurum
          .filter((_, index) => index !== tamamlandiIndex && index !== gecersizIndex)   
          .reduce((acc, value) => acc + value, 0);   
          return toplam
    },
    ToplamTalep(Durumlar){  
        const toplam = Durumlar.GetTalepDurum 
          .reduce((acc, value) => acc + value, 0);   
          return toplam
    }
  },
  async created() {
    if (!window.$cookies.get("ecampususer")) {
 
      if (this.$route.params.Sessionkey && this.$route.params.Email) {
        let Data = {
          Email: this.$route.params.Email,
          Sessionkey: this.$route.params.Sessionkey
        }
        this.ActionsLoginSessionKey(Data).then((res) => {
          if (res == true) {
            window.location.href = "/";
          } else {

            window.location.href = "/login"
          }
        });
      } else {

        window.location.href = "/login"
      }


    }
    else {
      await this.ActionsFilterGet({ Service: "okeyvalues", FullData: true, Filter: "&Asc=Kod&Tip=4" }).then((res) => { 
        res.Data.forEach(element => {
          this.Durumlar.labels.push(element.Value)
          this.DurumlarBireysel.labels.push(element.Value)
        });
        
      });
      

      var GetTalepDurum = await this.ActionsFilterGet({ Service: "tlptalep/GetTalepDurum", FullData: true, Filter: "", })
          GetTalepDurum.Data.forEach(element => {
            this.Durumlar.GetTalepDurum.push(element.Talepsayisi)
          });

      var GetTalepDurumYil = await this.ActionsFilterGet({ Service: "tlptalep/GetTalepDurum", FullData: true, Filter: "&Olusturmatarihyil=" + new Date().getFullYear(), })
          GetTalepDurumYil.Data.forEach(element => {
            this.Durumlar.GetTalepDurumYil.push(element.Talepsayisi)
          });

      var GetTalepDurumAy = await this.ActionsFilterGet({Service: "tlptalep/GetTalepDurum", FullData: true,Filter: "&Olusturmatarihyil=" + new Date().getFullYear() + "&Olusturmatarihay=" + (parseInt(new Date().getMonth()) + 1),})
          GetTalepDurumAy.Data.forEach(element => {
            this.Durumlar.GetTalepDurumAy.push(element.Talepsayisi)
          });
          

      var GetTalepDurumBireysel = await this.ActionsFilterGet({ Service: "tlptalep/GetTalepDurum", FullData: true, Filter: "&Olusturanid="+this.TokenPersonelId, })
      GetTalepDurumBireysel.Data.forEach(element => {
            this.DurumlarBireysel.GetTalepDurum.push(element.Talepsayisi)
          });

      var GetTalepDurumYilBireysel = await this.ActionsFilterGet({ Service: "tlptalep/GetTalepDurum", FullData: true, Filter: "&Olusturmatarihyil=" + new Date().getFullYear() + "&Olusturanid="+this.TokenPersonelId, })
      GetTalepDurumYilBireysel.Data.forEach(element => {
            this.DurumlarBireysel.GetTalepDurumYil.push(element.Talepsayisi)
          });

      var GetTalepDurumAyBireysel = await this.ActionsFilterGet({Service: "tlptalep/GetTalepDurum", FullData: true,Filter: "&Olusturmatarihyil=" + new Date().getFullYear() + "&Olusturmatarihay=" + (parseInt(new Date().getMonth()) + 1) + "&Olusturanid="+this.TokenPersonelId,})
          GetTalepDurumAyBireysel.Data.forEach(element => {
            this.DurumlarBireysel.GetTalepDurumAy.push(element.Talepsayisi)
          });

    }

  },
  mounted() {
    setTimeout(() => {
      this.showModal = true;
    }, 1500);
  },
};
</script>

<template>
  <Layout> 

    <template v-if="KullaniciYetkileri.find(item => item === 'TlpAdmin')">
      <p class="section-heading"><i class="bx bx-shield-quarter"></i>Genel Durum</p>

      <div class="row">
        <div class="col-lg-3 col-sm-6">
          <div class="card stat-card">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="stat-icon stat-icon-warning">
                  <i class="bx bx-time-five"></i>
                </div>
                <div class="ms-3">
                  <p class="stat-label mb-1">Tamamlanmayan Talep Sayısı</p>
                  <h3 class="stat-value mb-0">{{ TamamlanmayanaTalep(Durumlar) }}</h3>
                </div>
              </div>
            </div>
            <span class="stat-card-accent stat-icon-warning"></span>
          </div>
        </div>

        <div class="col-lg-3 col-sm-6">
          <div class="card stat-card">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="stat-icon stat-icon-success">
                  <i class="bx bx-check-circle"></i>
                </div>
                <div class="ms-3">
                  <p class="stat-label mb-1">Tamamlanan Talep Sayısı</p>
                  <h3 class="stat-value mb-0">{{ TamamlananTalep(Durumlar) }}</h3>
                </div>
              </div>
            </div>
            <span class="stat-card-accent stat-icon-success"></span>
          </div>
        </div>

        <div class="col-lg-3 col-sm-6">
          <div class="card stat-card">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="stat-icon stat-icon-danger">
                  <i class="bx bx-x-circle"></i>
                </div>
                <div class="ms-3">
                  <p class="stat-label mb-1">Geçersiz Talep Sayısı</p>
                  <h3 class="stat-value mb-0">{{ GecersizTalep(Durumlar) }}</h3>
                </div>
              </div>
            </div>
            <span class="stat-card-accent stat-icon-danger"></span>
          </div>
        </div>

        <div class="col-lg-3 col-sm-6">
          <div class="card stat-card">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="stat-icon stat-icon-primary">
                  <i class="bx bx-collection"></i>
                </div>
                <div class="ms-3">
                  <p class="stat-label mb-1">Toplam Talep Sayısı</p>
                  <h3 class="stat-value mb-0">{{ ToplamTalep(Durumlar) }}</h3>
                </div>
              </div>
            </div>
            <span class="stat-card-accent stat-icon-primary"></span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4">
          <div class="card chart-card">
            <div class="card-body">
              <h4 class="chart-card-title"><i class="bx bx-calendar"></i>Talep Durumları Aylık</h4>
              <apexchart class="apex-charts" height="320" type="pie" dir="ltr" :series="Durumlar.GetTalepDurumAy"
                :options="Durumlar"></apexchart>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card chart-card">
            <div class="card-body">
              <h4 class="chart-card-title"><i class="bx bx-calendar-alt"></i>Talep Durumları Yıllık</h4>
              <apexchart class="apex-charts" height="320" type="pie" dir="ltr" :series="Durumlar.GetTalepDurumYil"
                :options="Durumlar"></apexchart>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card chart-card">
            <div class="card-body">
              <h4 class="chart-card-title"><i class="bx bx-pie-chart-alt-2"></i>Talep Durumları Genel</h4>
              <apexchart class="apex-charts" height="320" type="pie" dir="ltr" :series="Durumlar.GetTalepDurum"
                :options="Durumlar"></apexchart>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-if="KullaniciYetkileri.find(item => item === 'TlpKullanici')">
      <p class="section-heading"><i class="bx bx-user-circle"></i>Taleplerim</p>

      <div class="row">
        <div class="col-lg-4 col-sm-6">
          <div class="card stat-card stat-card-clickable" @click='this.$router.push({ name: "tlptaleplerim" })'>
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="stat-icon stat-icon-warning">
                  <i class="bx bx-time-five"></i>
                </div>
                <div class="ms-3">
                  <p class="stat-label mb-1">Tamamlanmayan Taleplerim</p>
                  <h3 class="stat-value mb-0">{{ TamamlanmayanaTalep(DurumlarBireysel) }}</h3>
                </div>
              </div>
            </div>
            <span class="stat-card-accent stat-icon-warning"></span>
          </div>
        </div>

        <div class="col-lg-4 col-sm-6" v-if="KullaniciYetkileri.find(item => item === 'TlpAdmin')">
          <div class="card stat-card">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="stat-icon stat-icon-success">
                  <i class="bx bx-check-circle"></i>
                </div>
                <div class="ms-3">
                  <p class="stat-label mb-1">Tamamlanan Taleplerim</p>
                  <h3 class="stat-value mb-0">{{ TamamlananTalep(DurumlarBireysel) }}</h3>
                </div>
              </div>
            </div>
            <span class="stat-card-accent stat-icon-success"></span>
          </div>
        </div>

        <div class="col-lg-4 col-sm-6">
          <div class="card stat-card">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="stat-icon stat-icon-primary">
                  <i class="bx bx-collection"></i>
                </div>
                <div class="ms-3">
                  <p class="stat-label mb-1">Toplam Taleplerim</p>
                  <h3 class="stat-value mb-0">{{ ToplamTalep(DurumlarBireysel) }}</h3>
                </div>
              </div>
            </div>
            <span class="stat-card-accent stat-icon-primary"></span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4">
          <div class="card chart-card">
            <div class="card-body">
              <h4 class="chart-card-title"><i class="bx bx-calendar"></i>Aylık Talep Durumum</h4>
              <apexchart class="apex-charts" height="320" type="pie" dir="ltr"
                :series="DurumlarBireysel.GetTalepDurumAy" :options="DurumlarBireysel"></apexchart>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card chart-card">
            <div class="card-body">
              <h4 class="chart-card-title"><i class="bx bx-calendar-alt"></i>Yıllık Talep Durumum</h4>
              <apexchart class="apex-charts" height="320" type="pie" dir="ltr"
                :series="DurumlarBireysel.GetTalepDurumYil" :options="DurumlarBireysel"></apexchart>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card chart-card">
            <div class="card-body">
              <h4 class="chart-card-title"><i class="bx bx-pie-chart-alt-2"></i>Genel Talep Durumum</h4>
              <apexchart class="apex-charts" height="320" type="pie" dir="ltr" :series="DurumlarBireysel.GetTalepDurum"
                :options="DurumlarBireysel"></apexchart>
            </div>
          </div>
        </div>
      </div>
    </template>

    <div class="row" v-if="KullaniciYetkileri.lenght > 0">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="empty-state">
              <i class="bx bx-lock-alt"></i>
              <h3>Yetkiniz bulunmamaktadır</h3>
              <p>Bu sayfayı görüntülemek için lütfen yetki talep edin.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>

<style scoped>
.section-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1rem;
  font-weight: 600;
  color: #495057;
  margin: 0 0 14px;
}

.section-heading i {
  font-size: 1.15rem;
  color: #556ee6;
}

/* ---------- Stat cards ---------- */

.stat-card {
  position: relative;
  overflow: hidden;
  border: none;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.stat-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);
}

.stat-card-clickable {
  cursor: pointer;
}

.stat-card-accent {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
}

.stat-icon {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

.stat-icon-primary {
  background-color: rgba(85, 110, 230, 0.12);
  color: #556ee6;
}

.stat-icon-success {
  background-color: rgba(52, 195, 143, 0.12);
  color: #34c38f;
}

.stat-icon-warning {
  background-color: rgba(241, 180, 76, 0.15);
  color: #f1b44c;
}

.stat-icon-danger {
  background-color: rgba(244, 106, 106, 0.12);
  color: #f46a6a;
}

.stat-label {
  font-size: 0.82rem;
  color: #74788d;
}

.stat-value {
  font-size: 1.6rem;
  font-weight: 700;
  color: #343a40;
}

/* ---------- Chart cards ---------- */

.chart-card {
  border: none;
  transition: box-shadow 0.18s ease;
}

.chart-card:hover {
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);
}

.chart-card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 1.25rem;
}

.chart-card-title i {
  font-size: 1.1rem;
  color: #556ee6;
}

/* ---------- Empty state ---------- */

.empty-state {
  text-align: center;
  padding: 48px 16px;
}

.empty-state i {
  font-size: 2.75rem;
  color: #74788d;
  opacity: 0.6;
}

.empty-state h3 {
  margin-top: 16px;
  font-weight: 600;
}

.empty-state p {
  color: #74788d;
  margin-bottom: 0;
}
</style>
